var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PASS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 152",
    style: {
      enableBackground: "new 0 0 166 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCB03;}\n\t.st1{fill:none;stroke:#FFCB03;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 56.1,
    cy: 51.19,
    r: 9.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.71,87.8H37.98v-9.44c0-8.95,7.25-16.2,16.2-16.2h3.32c8.95,0,16.2,7.25,16.2,16.2V87.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 89.14,
    y1: 53.79,
    x2: 131.03,
    y2: 53.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 89.14,
    y1: 62.06,
    x2: 131.03,
    y2: 62.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 89.14,
    y1: 71.98,
    x2: 131.03,
    y2: 71.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.86,33.41h-11.7H31.18c-4.5,0-8.14,3.64-8.14,8.14v22.46v37.69c0,4.5,3.64,8.14,8.14,8.14h24.18v-9.2 c0-2.12,1.74-3.86,3.86-3.86c2.12,0,3.86,1.74,3.86,3.86v9.2h41.89v-9.2c0-2.12,1.74-3.86,3.86-3.86c2.12,0,3.86,1.74,3.86,3.86 v9.2h24.18c4.5,0,8.14-3.64,8.14-8.14V41.55C145,37.06,141.36,33.41,136.86,33.41z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqAccount);
export default __webpack_public_path__ + "static/media/faq-account.29d44d9fe04a0fb388c49a11f4876dd6.svg";
export { ForwardRef as ReactComponent };